export default "__VITE_ASSET__B09jWWV___"